// Compile our scss
// This 'includes' the SCSS index file which webpack then reads and 
// compiles into the necessary css files
require('../scss/index.scss');

require('./base.js');

function PageSetup(){
	
	if($('#g_map_locations'.length > 0)){
		mapInit();
		mapNav();
	}

}

var map;

function mapInit() {

	var mapOptions = {
		zoom: 14,
		scrollwheel: false,
		zoomControl: true,
		mapTypeControl: false,
		scaleControl: false,
		navigationControl: false,
		draggable: true,
		streetViewControl: false,
		rotateControl: false,
		fullscreenControl: false
	}
	
	// Create the map object.
	map = new google.maps.Map(document.getElementById('g_map_locations'), mapOptions);

	var bounds = new google.maps.LatLngBounds();
	map.fitBounds(bounds, 100);

	markers = [];

	// For each location create a marker if ShowMarker is checked
	$('.location_data').each(function(){

		if ($(this).data('marker')) {
			var marker = new google.maps.Marker({
				position: {
					lat: parseFloat($(this).data('lat')),
					lng: parseFloat($(this).data('lng'))
				},
				icon: new google.maps.MarkerImage('app/images/map-marker.svg',
				null, null, null, new google.maps.Size(68,68)),
				map: map
			});
			marker.set('id', $(this).attr('id'));
			markers.push(marker);

			return bounds.extend({
				lat: parseFloat($(this).data('lat')), 
				lng: parseFloat($(this).data('lng'))
			});
		} else {
			return;
		}
	});

}

function mapNav() {

	// Get all the nav buttons.
	var link = $("#accordion button");

	// On clicking of the links do something.
	link.on('click', function(e) {

		var location = $(this).closest('.accordion-item').find('.location_data');
		var locationName = $(this).closest('.accordion-item').find('.location-name');

		$('.location-name').removeClass('initial-view');
		$('.location_data').removeClass('initial-view');
		$('#accordion').removeClass('initial-view');

		var isMobileMode = $(document).find('#js-mobile-mode').css('display');

		if(!location.hasClass('active')){

			if(isMobileMode == 'block') {
				$('.location_data').slideUp().removeClass('active');
				$('.location-name').removeClass('active');
				location.slideDown().addClass('active');
				locationName.addClass('active');
			} else {
				$('.location_data').removeClass('active');
				$('.location-name').removeClass('active');
				location.addClass('active');
				locationName.addClass('active');
			}
		} else {
			if(isMobileMode == 'block') {
				$('.location_data').removeClass('active').slideDown().addClass('initial-view');
				$('.location-name').removeClass('active').slideDown().addClass('initial-view');
				$('#accordion').addClass('initial-view');
			} else {
				$('.location_data').removeClass('active').addClass('initial-view');
				$('.location-name').removeClass('active').addClass('initial-view');
				$('#accordion').addClass('initial-view');
			}
		}

		if($('#accordion').hasClass('initial-view')) {
			mapInit();
		} else {
			if(location.attr('data-marker') == 0){
				map.setCenter({
					lat: parseFloat(location.attr('data-lat')),
					lng: parseFloat(location.attr('data-lng'))
				});
				map.setZoom(12); // zoom out (as not specific location)
			} else {
				var markerTarget = $(this).attr('data-target');
				$.each(markers, function(key, marker){
					if(marker.id === markerTarget){
						map.setZoom(14);
						map.panTo(marker.getPosition());
					}
				});
			}
		}
	});

	var directionsLink = $("#accordion a g-directions");

	directionsLink.on('click', function(e) {
		return true;
   });
}


/**
 * On page load
 **/
$(document).ready( function(){
	// Start your website!
	PageSetup();
});